// @ts-nocheck
// Vendored from tailuge/billiards (GPL-3.0) — src/view/balltexturefactory.ts
// 番号・ストライプを描いた CanvasTexture を生成（自己完結）。
import { CanvasTexture, Color } from "three"

export class BallTextureFactory {
  private static readonly textureCache: Map<string, CanvasTexture> = new Map()

  static getOrCreateTexture(label: number, color: Color, size = 256): CanvasTexture {
    const key = `${label}_${color.getHex()}_${size}`
    if (this.textureCache.has(key)) {
      return this.textureCache.get(key)!
    }
    const texture = this.createNumberTexture(label, color, size)
    this.textureCache.set(key, texture)
    return texture
  }

  /** マーク付き練習用手球（白地・赤ドット）。回転が視認できる。 */
  static getOrCreateCueTexture(size = 256): CanvasTexture {
    const key = `cue_practice_${size}`
    if (this.textureCache.has(key)) {
      return this.textureCache.get(key)!
    }
    const canvas = document.createElement("canvas")
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext("2d")
    if (!ctx) {
      const t = new CanvasTexture(canvas)
      this.textureCache.set(key, t)
      return t
    }
    ctx.fillStyle = "#f6f6f2"
    ctx.fillRect(0, 0, size, size)
    const cx = size / 2
    const cy = size / 2
    const dot = size * 0.05
    const drawDot = (x: number, y: number) => {
      ctx.beginPath()
      ctx.arc(x, y, dot, 0, Math.PI * 2)
      ctx.fillStyle = "#d11"
      ctx.fill()
    }
    drawDot(cx, cy)
    const rings = [
      { r: size * 0.3, n: 6, off: 0 },
      { r: size * 0.44, n: 6, off: Math.PI / 6 },
    ]
    for (const ring of rings) {
      for (let i = 0; i < ring.n; i++) {
        const a = ring.off + (i * 2 * Math.PI) / ring.n
        drawDot(cx + Math.cos(a) * ring.r, cy + Math.sin(a) * ring.r)
      }
    }
    const texture = new CanvasTexture(canvas)
    texture.flipY = false
    this.textureCache.set(key, texture)
    return texture
  }

  private static createNumberTexture(label: number, color: Color, size: number): CanvasTexture {
    const scale = size / 256
    const canvas = document.createElement("canvas")
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext("2d")
    if (!ctx) {
      return new CanvasTexture(canvas)
    }

    ctx.fillStyle = `#${color.getHexString()}`
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    // Stripes for 9-15
    if (label >= 9) {
      ctx.fillStyle = "white"
      ctx.fillRect(0, 0, size, size * 0.2)
      ctx.fillRect(0, size * 0.8, size, size * 0.2)
    }

    if (label > 0) {
      const centerX = size / 2
      const centerY = size / 2
      const radius = Math.round(52 * scale)
      const border = Math.round(15 * scale)

      ctx.beginPath()
      ctx.arc(centerX, centerY, radius + border, 0, Math.PI * 2)
      ctx.fillStyle = "black"
      ctx.fill()

      ctx.beginPath()
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2)
      ctx.fillStyle = "white"
      ctx.fill()

      ctx.fillStyle = "black"
      ctx.strokeStyle = "black"
      const fontSize = Math.round(97 * scale)
      ctx.lineWidth = fontSize * 0.05
      ctx.font = `900 ${fontSize}px "Arial Black", Arial, sans-serif`
      ctx.textAlign = "center"
      ctx.textBaseline = "middle"
      const textX = centerX
      const textY = centerY + Math.round(5 * scale)
      ctx.strokeText(label.toString(), textX, textY)
      ctx.fillText(label.toString(), textX, textY)
    }

    const texture = new CanvasTexture(canvas)
    texture.flipY = false
    return texture
  }
}
